import React from 'react';
import { autoId, ExternalLink } from '@workday/upc-common';
import './upc-footer.scss';
import { WdayLogo } from '../../shared';
import { useTranslation } from 'react-i18next';
import { FAQ_PATH } from '../../react-router-paths';
import { TranslatedExternalLink } from '../translated-external-link';

interface UpcFooterProps {
    className?: string;
    isAuthenticated?: boolean;
}

export function UpcFooter({ isAuthenticated }: UpcFooterProps) {
    const currentYear = new Date().getFullYear();
    const { t } = useTranslation('shared');
    return (
        <footer className='upcFooter' role='contentinfo'>
            {isAuthenticated ? (
                <div className='upcFooter__logoRow'>
                    <WdayLogo />
                </div>
            ) : null}
            <div className='upcFooter__descRow'>
                &copy; {currentYear}. {t('Shared.footerText')}
            </div>

            <div className='upcFooter__linksRow'>
                <ul>
                    <li className='upcFooter__link'>
                        <ExternalLink href={FAQ_PATH} {...autoId('faqLink')}>
                            {t('Shared.faqText')}
                        </ExternalLink>
                    </li>
                    <li className='upcFooter__link'>
                        <TranslatedExternalLink translationKey='privacyUrl' {...autoId('privacyPolicyLink')}>
                            {t('Shared.privacyText')}
                        </TranslatedExternalLink>
                    </li>
                    <li className='upcFooter__link'>
                        <TranslatedExternalLink translationKey='termsUrl' {...autoId('termsOfUseLink')}>
                            {t('Shared.termsText')}
                        </TranslatedExternalLink>
                    </li>
                </ul>
            </div>
        </footer>
    );
}
